import Button from "@mui/material/Button/Button";

interface IPrimaryButton {
    name: string;
}

export const PrimaryButton = (prop: IPrimaryButton) => {


    return (
        <Button sx={{margin: 'auto',mb: 2, width: 150}}
          variant="contained" 
          color='primary'
          type="submit">{prop.name}
        </Button>
    )
}